// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_font-awesome@4.7.0@font-awesome/css/font-awesome.min.css
// module id = 857
// module chunks = 41